import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { PnDesfechoLead } from '@/hooks/useLeadsCarteira';

const API_BASE = (import.meta.env.VITE_SUPABASE_URL ?? 'https://beta.crm-api.primetecia.com.br/api').replace(/\/$/, '');

export function usePnDesfechosLeads(leadIds: string[]) {
  const ids = Array.from(new Set(leadIds.filter(Boolean))).sort();

  return useQuery({
    queryKey: ['leads-carteira', 'pn-desfechos', ids],
    enabled: ids.length > 0,
    staleTime: 300_000,
    queryFn: async (): Promise<Record<string, PnDesfechoLead>> => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.access_token) return {};

      const params = new URLSearchParams({ leadIds: ids.join(',') });
      const response = await fetch(`${API_BASE}/v1/leads-carteira/pn-desfechos?${params.toString()}`, {
        headers: { Authorization: `Bearer ${session.access_token}` },
      });
      if (!response.ok) throw new Error('Não foi possível consultar o desfecho da portabilidade');

      const payload = await response.json();
      return Object.fromEntries(
        ((payload?.data || []) as PnDesfechoLead[]).map((item) => [item.lead_id, item]),
      );
    },
  });
}
